import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import colors from 'common/constants/colors';
import ProductFactGrid from './ProductFactGrid';
import ProductIdChip from './ProductIdChip';

// POM-6600 — the catalog product a new NDC is about to be linked to. The same card is on both steps
// of Add Inventory Item, so what the user confirms reads exactly like what they picked.
const CatalogProductCard = ({
  label,
  productName,
  productId,
  facts,
  columnCount,
  hasCheckIcon,
  testId,
  children,
}) => (
  <Box
    data-testid={testId}
    sx={{
      p: 2,
      borderRadius: 1,
      bgcolor: colors.selectedProductNavyTint,
      borderLeft: '4px solid',
      borderLeftColor: 'primary.main',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
      {hasCheckIcon && <CheckCircleOutlineIcon color='primary' sx={{ fontSize: '1.1rem' }} />}
      <Typography
        variant='caption'
        sx={{ fontWeight: 700, letterSpacing: '0.08em', color: 'primary.main' }}
      >
        {label}
      </Typography>
    </Box>
    <Box
      sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}
    >
      <Typography variant='subtitle1' sx={{ fontWeight: 700, color: 'primary.main', mb: 1.5 }}>
        {productName}
      </Typography>
      <ProductIdChip productId={productId} />
    </Box>
    <ProductFactGrid facts={facts} columnCount={columnCount} />
    {children}
  </Box>
);

CatalogProductCard.propTypes = {
  label: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  productId: PropTypes.string,
  facts: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string.isRequired })).isRequired,
  columnCount: PropTypes.number,
  hasCheckIcon: PropTypes.bool,
  testId: PropTypes.string,
  children: PropTypes.node,
};
CatalogProductCard.defaultProps = {
  productId: undefined,
  columnCount: 2,
  hasCheckIcon: false,
  testId: undefined,
  children: null,
};

export default CatalogProductCard;
